import React from "react";
import { useFormContext } from "react-hook-form";
import AddLineIcon from "remixicon-react/AddLineIcon";
import { Button } from "$components";
import GenericSelect from "$forms/GenericSelect";
import CField, { CFieldInputProps } from "$forms/CField";
import CompanySelect from "$forms/CompanySelect";
import { getDeliveryTypeOptions } from "$utils/typeConstants";
import { useStyles } from "./styles";
import { useAssignCarrier } from "./context/AssignCarrierContext";

export const AssignCarrierBasicInfo: React.FC = () => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();
  const classes = useStyles();

  const {
    isCommissionCompanySelectDisplayed,
    isCarrierCompanySelectDisplayed,
    isAgencyCompanySelectDisplayed,
    isCommissionCompanySelectRequired,
    isCarrierCompanySelectRequired,
    isAgencyCompanySelectRequired,
    carrierOptions,
    agencyOptions,
    handleAddCompanyClick,
  } = useAssignCarrier();

  return (
    <>
      <div className={classes.lineContainer}>
        <CField
          required
          control={control}
          name="deliveryType"
          error={errors.deliveryType}
        >
          {(props: CFieldInputProps) => (
            <GenericSelect
              {...props}
              label="Sélectionner un type d'envoi"
              options={getDeliveryTypeOptions()}
            />
          )}
        </CField>
      </div>
      {isCommissionCompanySelectDisplayed && (
        <div className={classes.lineContainer}>
          <div className={classes.inputContainer}>
            <CField
              required={isCommissionCompanySelectRequired}
              control={control}
              name="commissionCompanyId"
              error={errors.commissionCompanyId}
            >
              {(props: CFieldInputProps) => (
                <CompanySelect
                  {...props}
                  ignoreSideBarCompanyFilter
                  placeholder=""
                  label="Sélectionner un commissionnaire existant"
                  companyOptions={carrierOptions}
                  allowPopperFlip={false}
                />
              )}
            </CField>
          </div>
          <div className={classes.addButtonContainer}>
            <Button
              className={classes.addButton}
              onClick={() => handleAddCompanyClick("commissionCompanyId")}
            >
              <AddLineIcon />
            </Button>
          </div>
        </div>
      )}
      {isCarrierCompanySelectDisplayed && (
        <div className={classes.lineContainer}>
          <div className={classes.inputContainer}>
            <CField
              required={isCarrierCompanySelectRequired}
              control={control}
              name="carrierCompanyId"
              ref={register("carrierCompanyId", {
                required: isCarrierCompanySelectRequired,
              })}
              error={errors.carrierCompanyId}
            >
              {(props: CFieldInputProps) => (
                <CompanySelect
                  {...props}
                  ignoreSideBarCompanyFilter
                  placeholder=""
                  label="Sélectionner un transporteur existant"
                  companyOptions={carrierOptions}
                  allowPopperFlip={false}
                />
              )}
            </CField>
          </div>
          <div className={classes.addButtonContainer}>
            <Button
              className={classes.addButton}
              onClick={() => handleAddCompanyClick("carrierCompanyId")}
            >
              <AddLineIcon />
            </Button>
          </div>
        </div>
      )}
      {isAgencyCompanySelectDisplayed && (
        <div className={classes.lineContainer}>
          <div className={classes.inputContainer}>
            <CField
              control={control}
              required={isAgencyCompanySelectRequired}
              name="agencyCompanyId"
              error={errors.agencyCompanyId}
            >
              {(props: CFieldInputProps) => (
                <CompanySelect
                  {...props}
                  ignoreSideBarCompanyFilter
                  placeholder=""
                  label="Sélectionner une agence existante"
                  companyOptions={agencyOptions}
                  allowPopperFlip={false}
                />
              )}
            </CField>
          </div>
          <div className={classes.addButtonContainer}>
            <Button
              className={classes.addButton}
              onClick={() => handleAddCompanyClick("agencyCompanyId")}
            >
              <AddLineIcon />
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default AssignCarrierBasicInfo;
